// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.loginWrapper {
  min-height: 100vh;
}

.white-label-bg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 560px;
  background-size: 120% !important;
  background-repeat: no-repeat !important;
  background-position: left center !important;
}

.loginWrapperInner {
  width: 320px;
  position: relative;
  text-align: center;
  z-index: 9;
  border-radius: 4px;
  float: right;
  min-height: 100vh;
  right: 10%;
  display: flex;
  align-items: center;
  margin: 0px;
  padding: 0px;
}

.login-logo-wrapper {
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  padding: 0px;
  margin-bottom: 30px;
}

.loginForm {
  flex: 1 1;
}
.loginForm .form-control {
  height: 42px;
  font-size: 16px;
  box-shadow: none;
  border-width: 0 0 1px;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
}
.loginForm .form-control:focus {
  box-shadow: none;
  border-bottom-width: 2px;
  border-bottom-color: #00c179;
}
.loginForm .control-label {
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
}
.loginForm .btn-submit {
  min-width: 150px !important;
  font-size: 14px;
  margin-top: 30px;
}

.login-footer a ~ a:before {
  content: "●";
  display: inline-block;
  margin-right: 12px;
  margin-left: 12px;
}
.login-footer {
  border-top: 1px solid #201d1d;
  padding-top: 15px;
}

@media (max-width: 599px) {
  .loginWrapperInner {
    width: 100%;
    padding: 50px 20px;
  }
  .login-logo-wrapper {
    margin-bottom: 40px;
  }
  .loginForm .btn-submit {
    margin-top: 15px;
  }
  .login-footer {
    left: 30px;
    right: 30px;
    font-size: 12px;
  }
  .loginWrapper {
    display: flex;
    height: 97vh;
    align-items: center;
    background: #fff;
  }
  .loginForm {
    box-shadow: none !important;
    width: 100%;
    margin: 0 !important;
  }
}
.login-logo {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Login/Style.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACC,iBAAA;AACD;;AAGA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,YANgB;EAOhB,gCAAA;EACG,uCAAA;EACA,2CAAA;AAAJ;;AAEA;EACC,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AACD;;AAUA;EACC,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,YAAA;EACA,mBAAA;AARD;;AAUA;EACC,SAAA;AAPD;AAQC;EACC,YAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AANF;AAOE;EACC,gBAAA;EACA,wBAAA;EACA,4BC5DU;ADuDb;AAQC;EACC,0BAAA;EACA,eAAA;AANF;AASC;EACC,2BAAA;EACA,eAAA;EACA,gBAAA;AAPF;;AAYC;EACC,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;AATF;AAIA;EAOC,6BAAA;EACG,iBAAA;AARJ;;AAqBA;EACC;IACC,WAAA;IACA,kBAAA;EAlBA;EAoBD;IACC,mBAAA;EAlBA;EAoBD;IACC,gBAAA;EAlBA;EAoBD;IACC,UAAA;IACA,WAAA;IACA,eAAA;EAlBA;EAoBD;IACC,aAAA;IACA,YAAA;IACA,mBAAA;IACA,gBAAA;EAlBA;EAoBD;IACC,2BAAA;IACA,WAAA;IACA,oBAAA;EAlBA;AACF;AAsBA;EACC,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AApBD","sourcesContent":["@import \"../../assets/variables\";\n.loginWrapper {\n\tmin-height: 100vh;\n}\n\n$loginFormWidth: 560px;\n.white-label-bg {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: $loginFormWidth;\n\tbackground-size: 120% !important;\n    background-repeat: no-repeat !important;\n    background-position: left center !important\n}\n.loginWrapperInner {\n\twidth: 320px;\n\tposition: relative;\n\ttext-align: center;\n\tz-index: 9;\n\tborder-radius: 4px;\n\tfloat: right;\n\tmin-height: 100vh;\n\tright:10%;\n\tdisplay: flex;\n\talign-items: center;\n\tmargin:0px;\n\tpadding: 0px;\n\t// box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12);\t\n\t// box-sizing: border-box;\n\t// margin-left: auto;\n\n\t// width: 30%;\n    // border-radius: 8px;\n    // margin: 80px;\n    // padding: 100px 50px;\n\t\n}\n.login-logo-wrapper {\n\theight: 72px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t// background: #fff;\n\tborder-radius: 6px;\n\tpadding: 0px;\n\tmargin-bottom: 30px;\n}\n.loginForm {\n\tflex: 1;\n\t.form-control {\n\t\theight: 42px;\n\t\tfont-size: 16px;\n\t\tbox-shadow: none;\n\t\tborder-width: 0 0 1px;\n\t\tborder-radius: 0;\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t\t&:focus {\n\t\t\tbox-shadow: none;\n\t\t\tborder-bottom-width: 2px;\n\t\t\tborder-bottom-color: $logoColor;\n\t\t}\n\t}\n\t.control-label {\n\t\tcolor: rgba(0, 0, 0, 0.54);\n\t\tfont-size: 12px;\n\t}\n\n\t.btn-submit {\n\t\tmin-width: 150px !important;\n\t\tfont-size: 14px;\n\t\tmargin-top: 30px;\n\t}\n\t\n}\n.login-footer {\n\ta ~ a:before {\n\t\tcontent: '\\25CF';\n\t\tdisplay: inline-block;\n\t\tmargin-right: 12px;\n\t\tmargin-left: 12px;\n\t}\n\tborder-top: 1px solid #201d1d;\n    padding-top: 15px;\n\t// position: absolute;\n\t// left: 0px;\n\t// width: 100%;\n\t// right: 100px;\n\t// display: flex;\n\t// height: 77px;\n\t// align-items: center;\n\t// justify-content: center;\n\t// bottom: 0;\n\t// text-align: center;\n}\n\n@media (max-width: 599px) {\n\t.loginWrapperInner {\n\t\twidth: 100%;\n\t\tpadding: 50px 20px;\n\t}\n\t.login-logo-wrapper {\n\t\tmargin-bottom: 40px;\n\t}\n\t.loginForm .btn-submit {\n\t\tmargin-top: 15px;\n\t}\n\t.login-footer {\n\t\tleft: 30px;\n\t\tright: 30px;\n\t\tfont-size: 12px;\n\t}\n\t.loginWrapper {\n\t\tdisplay: flex;\n\t\theight: 97vh;\n\t\talign-items: center;\n\t\tbackground: #fff;\n\t}\n\t.loginForm {\n\t\tbox-shadow: none !important;\n\t\twidth: 100%;\n\t\tmargin: 0 !important;\n\n\t}\n}\n\n.login-logo {\n\tmax-width: 100%;\n\tmax-height: 100%;\n\twidth: auto;\n\theight: auto;\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$sidebarWidth : 320px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 50px;\n$headerNavWidth: 50px;\n$headerNavWidthExpended: 200px;\n$headerHeight: 50px;\n$footerHeight: 0;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 3px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: #B2B5C4;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #e0e0e0;\n$lightGrey: #d7d7d7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 1;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 14px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Poppins, sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
